module.exports = __webpack_public_path__ + "img/warning-notice.576e3e7e.svg";